import { useSession } from 'next-auth/react';

export const useGetCurrentOrg = () => {
  const session = useSession();
  return session.data?.user?.organization || { type: undefined, id: undefined };
};
